import Cookies from 'js-cookie';
import { EVENT_TYPES } from './constants.js';
import events from './events.js';

const listeners = new Set();

const handleCookieUpdate = (e) => {
    const cookie = e.detail.value;
    listeners.forEach((listener) => listener(cookie));
};


const registerListener = (listener) => {
    if (listeners.size === 0) {
        window.addEventListener(EVENT_TYPES.COOKIE_UPDATE, handleCookieUpdate);
    }

    listeners.add(listener);
};

const unregisterListener = (listener) => {
    listeners.delete(listener);

    if (listeners.size === 0) {
        window.removeEventListener(EVENT_TYPES.COOKIE_UPDATE, handleCookieUpdate);
    }
};

export const subscribe = (listener) => {
    registerListener(listener);

    return () => {
        unregisterListener(listener);
    };
};

export const emit = (name, value) => {
    events.cookieUpdate.emit({ name, value });
};

export const getCookies = (name) => Cookies.get(name);

export const setCookie = (name, value, options) => {
    try {
        Cookies.set(name, value, options);
    } catch (err) {
        console.error('Failed to set cookie', { name, value, options }, err);
    }
    emit(name, value);
};

export const deleteCookie = (name, options) => {
    Cookies.remove(name, options);
    emit(name);
};
